import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@nerdwallet/currency';
import _ from 'lodash';
import Carousel from '@nerdwallet/react-carousel';
import { Impression } from '@nerdwallet/analytics/react/impression';
import {
  HOMEPAGE as analyticsBase,
  HOMEPAGE_SEGMENT_INSTRUMENTATION,
} from '../../../../lib/analytics-constants';
import SegmentImpression from '../../../segment-impression';
import SecondaryCampaignCard from '../secondary-campaign-card/secondary-campaign-card';
import styles from './secondary-campaign-carousel.module.less';

const SecondaryCampaignCarousel = ({ tiles }) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <SecondaryCampaignCard {...tile} key={`item-${nav}`} />
  ));

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={
        HOMEPAGE_SEGMENT_INSTRUMENTATION.secondary_campaign_module_carousel
      }
    >
      <Impression
        entityName={analyticsBase.entity_names.secondary_campaign_module}
        payload={{
          section_name: analyticsBase.section_name,
          registration_cohort: analyticsBase.cohort,
        }}
      >
        <div className={styles.secondaryCampaignCarouselContainer}>
          <Carousel
            id="secondary-campaign"
            entityName="secondary-campaign"
            decorateNav={false}
            enableDotNavigation
            arrows={false}
            dots
            inactiveDotColor="#000000"
            activeDotColor="#008255"
            slidesToShow="1.3"
            className={styles.secondaryCampaignCarousel}
          >
            {renderedTiles}
          </Carousel>
          <Divider />
        </div>
      </Impression>
    </SegmentImpression>
  );
};

SecondaryCampaignCarousel.displayName = 'SecondaryCampaignCarousel';

SecondaryCampaignCarousel.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(SecondaryCampaignCard.propTypes)),
};

export default SecondaryCampaignCarousel;
